import React, { Component } from 'react';

import { isNil } from 'lodash';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import {
  getProjectConditions,
  setActiveProjectSection,
  SINGLE_PROJECT_DATA_EXTRACTION_SECTION
} from '../data/projectActions';


import { SessionMessages, StartSessionModal, DownloadModal, WorkerForm} from '../components/fileImport/modals/index';
import SessionTable from '../components/fileImport/SessionTable';
import { closeAllModals, openWorkerFormModal } from '../data/fileImport/modalActions';
import { fetchProjectDataTrees,fetchTransformations} from '../data/fileImport/dataTreesActions';
import { getProjectSessions } from '../data/fileImport/sessionsActions';
import {
  removeActiveProjectContextListener,
  resetDataExtraction,
  setProjectContextListener,
  callAlbum
} from '../data/fileImport/fileImport';
import { getProjectFileTypes } from '../data/fileImport/dataFilesActions';

class FileImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasProject: false
    };

    this.closeAllModals = this.closeAllModals.bind(this);
    this.openWorkerModal = this.openWorkerModal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (isNil(nextProps.project)) {
      return null;
    }

    if (!prevState.hasProject && !isNil(nextProps.project)) {
      nextProps.dispatch(getProjectConditions(nextProps.project.id));
      nextProps.dispatch(getProjectSessions(nextProps.project.id));
      nextProps.dispatch(getProjectFileTypes(nextProps.project.id));
      
      nextProps.dispatch(fetchProjectDataTrees(nextProps.project.id));
      nextProps.dispatch(fetchTransformations());
      nextProps.dispatch(setProjectContextListener());
    }

    return {
      hasProject: !isNil(nextProps.project)
    };


  }

  callAlbumFunc(){
    this.props.dispatch(callAlbum());
  }

  componentDidMount() {
    this.props.dispatch(setActiveProjectSection(SINGLE_PROJECT_DATA_EXTRACTION_SECTION));
  }

  componentWillUnmount() {
    this.props.dispatch(removeActiveProjectContextListener());
    this.props.dispatch(resetDataExtraction());
  }

  /**
   * Return Current session
   * @param {int} sessionId
   */
  getCurrentSession(sessionId) {
    return sessionId ? this.props.sessions.find(session => session.id === sessionId) : {};
  }

  /**
   * Closes all modals
   */
  closeAllModals() {
    this.props.dispatch(closeAllModals());
  }

  /**
   * Opens workers modal
   */
  openWorkerModal() {
    this.props.dispatch(openWorkerFormModal());
  }

  render() {
    return (
      <div className="dashboard-global">
        <div className="dashboard-global_title-buttons">
          <h2 className="dashboard-global__main-title file-import_main-title">File Import</h2>
          <div className="button-group">
          <Button className="workerButton primary"
            onClick={this.openWorkerModal}
            > Workers </Button>
          <Button className="albumButton primary"
            onClick={e => {
              this.callAlbumFunc();
            }}
            > Album </Button>
          </div>
        </div>
        <div className="sessions__table--wrapper">
          <SessionTable
            fileTypes={this.props.fileTypes}
            sessions={this.props.sessions}
            project={this.props.project}
          />
        </div>
        <StartSessionModal
          participant={this.state.participant}
          isOpen={this.props.modals.startSession.isOpen}
          onRequestClose={this.closeAllModals}
          resourceId={this.props.modals.startSession.resourceId}
        />
        <SessionMessages
          isOpen={this.props.modals.messagesSession.isOpen}
          onRequestClose={this.closeAllModals}
          resourceId={this.props.modals.messagesSession.resourceId}
        />
        <WorkerForm
          isOpen={this.props.modals.workerForm.isOpen}
          onRequestClose={this.closeAllModals}
          resourceId={this.props.modals.workerForm.resourceId}
          project={this.props.project}
        />
        <DownloadModal
          isOpen={this.props.modals.downloadModal.isOpen}
          onRequestClose={this.closeAllModals}
          resourceId={this.props.modals.downloadModal.resourceId}
          files={[]}
          directories={[]}
        />
      </div>
    );
  }
}

export default connect(state => ({
  project: state.projects.single.active,
  sessions: state.projects.single.fileImport.sessions,
  fileTypes: state.projects.single.fileImport.fileTypes,
  modals: state.projects.single.fileImport.modals,
  projectTransformations: state.projects.single.fileImport.projectTransformations
}))(FileImport);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/containers/FileImport.js